import Vue from "vue"

Vue.filter("truncate", (str, length = 100, ending = "...") =>
  str && str.length > length
    ? str.substring(0, length - ending.length) + ending
    : str
)
